export default {
  生产物料: "生产性物料",
  非生产物料: "非生产性物料",
};
